/**
 * Query key factory for BTX rates
 *
 * Provides consistent query key generation for React Query cache management.
 */

/**
 * Query keys for rate schedules and rates
 */
export const rateQueryKeys = {
  /** Base key for all rate-related queries */
  all: ["btx", "rates"] as const,

  /** Prefix of every rate schedule list key, whatever the plan or the category */
  schedulesLists: ["btx", "rates", "schedules"] as const,

  /** Keys for rate schedule lists (current category only) */
  schedules: (benefitPlanId: string) =>
    [...rateQueryKeys.all, "schedules", benefitPlanId] as const,

  /**
   * Keys for the renewal-inclusive list (current + renewal + revisedRenewal).
   * Kept distinct from `schedules` so the default current-only read and this
   * opt-in read never overwrite each other in the cache.
   */
  schedulesWithRenewal: (benefitPlanId: string) =>
    [...rateQueryKeys.all, "schedules", "with-renewal", benefitPlanId] as const,

  /** Key for a single rate schedule */
  schedule: (scheduleId: string) =>
    [...rateQueryKeys.all, "schedule", scheduleId] as const,
};
